<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Rule</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column rule-modal-column rule-modal-first-column">
            <span class="modal-span">From Existing Rule</span>
            <b-field class="select-rule-name">
              <multiselect
                :value="rules.id"
                v-model="selectedRule"
                :options="rules"
                placeholder="Please select a rule"
                label="name"
                track-by="name"
                :searchable="true"
                :show-labels="false"
              ></multiselect>
            </b-field>

            <b-button
              slot="right"
              class="is-normal rule-button"
              @click="copyRule"
            >
              Copy
            </b-button>
          </div>
          <div class="column rule-modal-column">
            <span class="modal-span">Start Blank</span>
            <b-button
              slot="right"
              type="is-primary"
              @click="cancel"
              class="rule-button"
              v-on:click="submit"
            >
              Create New Rule
            </b-button>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import Multiselect from "vue-multiselect";
import RulesManagerService from "../../services/RulesManagerService";
// @group Dashboard
export default {
  name: "AddRules",
  mixins: [UtilityMixin, scopeMixin],
  components: { Multiselect },
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    viewOnly: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isModalActive: false,
      loading: "",
      selectedRule: null,
      rules: [],
      RulesManagerService: new RulesManagerService()
    };
  },
  mounted() {
    this.getRuleList();
  },
  methods: {
    getRuleList() {
      this.RulesManagerService.getAllRules().subscribe(response => {
        this.rules = response;
      });
    },
    copyRule() {
      this.$emit("copyRule", this.selectedRule.id);
    },
    cancel() {
      this.selectedRule = null;
      this.$emit("cancel");
    },

    submit() {
      this.$emit("addNew");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
